import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">实时快讯</h2>
          <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full">LIVE</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {updates.map((item) => (
            <a
              key={item.id}
              href="#updates"
              onClick={(e) => e.preventDefault()}
              className="group flex items-start gap-3 p-4 rounded-xl bg-background-100 hover:bg-primary-50/50 transition-colors border border-background-200/70 cursor-pointer"
            >
              <span className={`flex-shrink-0 px-2 py-0.5 rounded text-[10px] font-bold whitespace-nowrap mt-0.5 ${
                item.tag === '爆料' ? 'bg-primary-100 text-primary-700' :
                item.tag === '独家' ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                {item.tag}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors line-clamp-2 leading-relaxed">
                  {item.title}
                </p>
                <span className="text-xs text-foreground-400 mt-1 inline-block">{item.time}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}